import { FC } from "react";
import { i18n } from "rujira.ui";
import { Markets } from "./components/Markets";

export const TradeMarkets: FC = () => {
  return (
    <div className="rujira__main rujira__main--gradient pools">
      <div className="rujira__inner--pad">
        <div className="rujira__inner">
          <i18n.h1 className="h1">Trade</i18n.h1>

          <i18n.h2 className="fs-24 lh-32 fw-400 color-white mb-4">
            Buy & sell tokens on a fully on-chain order book exchange
          </i18n.h2>
          <Markets />
        </div>
      </div>
    </div>
  );
};
